import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';

interface DeleteOAuthAppInput {
  clientId: string;
  appId: string;
}

/**
 * Mutation hook for `DELETE /v1/clients/{clientId}/oauth-apps/{appId}`.
 * Casbin `(oauth-app, delete)` — Admin only (Operator + Viewer get 403).
 */
export function useDeleteOAuthAppMutation(): UseMutationResult<void, Error, DeleteOAuthAppInput> {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, appId }: DeleteOAuthAppInput) => {
      if (!api) throw new Error('useDeleteOAuthAppMutation: api client unavailable');
      return api.delete<void>(`/v1/clients/${clientId}/oauth-apps/${appId}`);
    },
    onSuccess: (_data, { clientId }) => {
      void queryClient.invalidateQueries({ queryKey: ['oauth-apps', clientId] });
    },
  });
}
